export const REDUCER_SET_META_DATA = 'REDUCER_SET_META_DATA'
export const REDUCER_CHECKPOINT = 'REDUCER_CHECKPOINT'
